
define(['underscore'], function(_) {
  var LocalStorage;
  return LocalStorage = (function() {

    function LocalStorage(key) {
      this.localStorageKey = 'LocalStorageStore-' + key;
    }

    LocalStorage.prototype.save = function(item) {
      return typeof localStorage !== "undefined" && localStorage !== null ? localStorage.setItem(this.localStorageKey, JSON.stringify(item)) : void 0;
    };

    LocalStorage.prototype.load = function() {
      return JSON.parse(typeof localStorage !== "undefined" && localStorage !== null ? localStorage.getItem(this.localStorageKey || {}) : void 0);
    };

    LocalStorage.prototype.remove = function(key) {
      if (key == null) {
        key = this.localStorageKey;
      }
      return typeof localStorage !== "undefined" && localStorage !== null ? localStorage.removeItem(key) : void 0;
    };

    return LocalStorage;

  })();
});
